import { render, staticRenderFns } from "./HizmetTanimla.vue?vue&type=template&id=ab62d6c0&scoped=true&"
import script from "./HizmetTanimla.vue?vue&type=script&lang=js&"
export * from "./HizmetTanimla.vue?vue&type=script&lang=js&"
import style0 from "./HizmetTanimla.vue?vue&type=style&index=0&id=ab62d6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab62d6c0",
  null
  
)

export default component.exports